module.exports = __webpack_public_path__ + "img/soccerboard129.6382b6e6.jpg";